import { useRouter } from 'next/router';
import { Container, TitleContainer, Form, Input, Button, InputContainer, Tooltip } from '../../styles/Cadastro';
import { useState } from 'react';

const RedefinirSenha = () => {

    const [email, setEmail] = useState('');
    const [chave, setChave] = useState('');
    const [step, setStep] = useState(1);
    const [senha, setSenha] = useState('');
    const [confirmarSenha, setConfirmarSenha] = useState('');

    const router = useRouter();

    const handleChave = (e) => {
        //cant have blank spaces
        setChave(e.target.value.replace(/\s/g, ''));
    }


    const handleEmailSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch('/api/resetPasswordByEmail', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ email })
            });
            if (response.status == 200 ) {
                alert("E-mail enviado com sucesso!");
                setStep(2);
            }
            
            if (response.status == 204 ) {
                alert("E-mail não cadastrado! Redirecionando para a página de cadastro...");
                router.push('/Cadastro');
            }

            return response.json();
            

            
        } catch (error) {
            console.error(error);
        }

    }

    const handleResetPasswordSubmit = async (e) => {
        e.preventDefault();

        if (senha !== confirmarSenha) {
            alert("As senhas não coincidem!");
            return;
        }

        

        try {
            const response = await fetch('/api/usuarios/senha', {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ email, chave, senha })
            });

            if (response.status == 200 ) {
                alert("Senha alterada com sucesso!");
                router.push('/Login');
            } else {
                alert("Erro ao alterar senha!");
            }



            return response.json();
            

            

            
        } catch (error) {
            console.error(error);
        }
    }

    return (
        <Container>
            
            {step === 1 && 
                <Form onSubmit={handleEmailSubmit}>
                <TitleContainer>
                    <h1>Esqueci minha senha</h1>
                    <h3> Insira seu e-mail para receber um link de redefinição de senha. </h3>
                </TitleContainer>
                <Input placeholder='E-mail' type='email' value={email} onChange={(e) => setEmail(e.target.value)} />
                <Button type="submit">Enviar</Button>

                    
                </Form>
            }

            {step === 2 && 
                <Form onSubmit={handleResetPasswordSubmit}>
                <TitleContainer>
                    <h1>Redefinir senha</h1>
                    <h3>Enviamos uma chave de redefinição para o e-mail {email}.</h3>
                    <h3>Insira a chave no campo abaixo e digite sua nova senha.</h3>
                </TitleContainer>
                <InputContainer>
                    <Input placeholder='Chave' type='key' value={chave} onChange={handleChave} />
                    <Input placeholder='Nova senha' type='password' value={senha} onChange={(e) => setSenha(e.target.value)} />
                    <Input placeholder='Confirmar nova senha' type='password' value={confirmarSenha} onChange={(e) => setConfirmarSenha(e.target.value)} />


                </InputContainer>
                <Button type="submit">Enviar</Button>

                    
                </Form>
            }
        </Container>
    )
}

export default RedefinirSenha;